import { render, staticRenderFns } from "./RegistrationStepperSection.vue?vue&type=template&id=28490568&scoped=true&"
import script from "./RegistrationStepperSection.vue?vue&type=script&lang=js&"
export * from "./RegistrationStepperSection.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationStepperSection.vue?vue&type=style&index=0&id=28490568&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28490568",
  null
  
)

export default component.exports